/**
 * Hand a blob to the browser as a file download.
 *
 * The object URL is revoked on the next macrotask, not straight after
 * `click()`. The click is dispatched synchronously, but the download it starts
 * is not: revoking in the same tick can pull the blob out from under a browser
 * that had not begun reading it, and the download then fails with nothing on
 * screen to say so. Chrome and Firefox happen to tolerate it, which is why the
 * two call sites this replaces had been working — it is not a guarantee, and
 * MDN says as much.
 *
 * There is no event for "the download has started", so a deferred revoke is the
 * conventional answer. The blob stays alive for one tick longer than strictly
 * needed; that is the whole cost.
 *
 * Only for blob URLs. A presigned URL needs none of this — assign it to the
 * anchor and click, as the batch/job history downloads do.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
